/*
 * @Author: shen
 * @Date: 2021-07-18 12:23:01
 * @LastEditors: shen
 * @LastEditTime: 2021-07-18 14:25:42
 * @Description:
 */
class Watcher {
  constructor(pageIns, mapState) {
    this.pageIns = pageIns
    this.mapState = mapState
  }

  update(state) {
    setTimeout(() => {
      this.pageIns.setData(state)
    }, 100)
  }
}

export default Watcher
